import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './Components/App/App';
import reportWebVitals from './reportWebVitals';
import firebase from 'firebase/app';
import "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const config = {
  apiKey: "AIzaSyAMcRt8cGWCyUVPDbQ-ZTmoD0gNh-AFjS0",
  authDomain: "eatly-demo.firebaseapp.com",
  projectId: "eatly-demo",
  storageBucket: "eatly-demo.appspot.com",
  messagingSenderId: "718165918878",
  appId: "1:718165918878:web:3fdd7f9de0a5c24fd7a78f",
  measurementId: "G-JEX54757N5"
};
firebase.initializeApp(config);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
